// import { useState } from "react";
import { FaWallet } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import walletAnimation from "../assets/walletAnimation.webm";
import { useState } from "react";
const WalletButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser, walletBalance } = useAuth();

  if (!currentUser) return null;

  const balance = parseFloat(walletBalance) || 0;

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="flex w-[100%] items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition"
        aria-label="Wallet balance"
      >
        <FaWallet className="text-xl" /> ₹{balance.toFixed(2)}
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl p-6 shadow-lg max-w-md w-full relative">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
              aria-label="Close wallet"
            >
              ✖
            </button>

            <div className="flex justify-center mb-6">
              <video autoPlay loop muted className="w-36 h-36 pointer-events-none">
                <source src={walletAnimation} type="video/webm" />
              </video>
            </div>

            <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
              Wallet Balance: ₹{balance.toFixed(2)}
            </h2>

            <div className="mt-6 text-center">
              <p className="text-red-500 font-semibold mb-4">
                Adding money to the wallet is temporarily disabled. You can still pay using your existing wallet balance.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WalletButton;